import { render, staticRenderFns } from "./AssetItemList.vue?vue&type=template&id=c1436840&scoped=true"
import script from "./AssetItemList.vue?vue&type=script&lang=js"
export * from "./AssetItemList.vue?vue&type=script&lang=js"
import style0 from "./AssetItemList.vue?vue&type=style&index=0&id=c1436840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1436840",
  null
  
)

export default component.exports